module.exports = "<h2>\n  <span class=\"point no-margin\" [ngStyle]=\"{background: color}\"></span>\n\n  Activators\n</h2>\n\n<ul class=\"feature oneline\">\n  <li *ngFor=\"let activator of sortedActivators\" style=\"height: 90px\">\n    <park-activator-control [activator]=\"activator[1]\" [activatorId]=\"activator[0]\" [parkId]=\"parkId\" [id]=\"id\"></park-activator-control>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/parks/park/controls/features/activators/park-activator-controls.html
// module id = ./src/app/dashboard/parks/park/controls/features/activators/park-activator-controls.html
// module chunks = main